import _ from 'underscore';
import Mn from 'backbone.marionette';

const AuthView = Mn.LayoutView.extend({
  el: 'body',

  ui: {
    auth: '#authenticate',
    progress: '#progress',
    username: '#username',
    password: '#password',
    success: '#success',
    last_url: '#last_transaction_url',
    import_after: '#import_after',
    upload_after: '#upload_after'
  },

  events: {
    'click @ui.auth': 'auth'
  },

  initialize() {
    this.model = new Backbone.Model();
    this.model.url = window.location.href;
    this.bindUIElements();
  },

  modelEvents: {
    sync: 'showStatusMessage'
  },

  showStatusMessage(model, response) {
    // we presume that if there's a response then there's an error
    if (response) {
      if (response.username || response.password) {
        window.messages.add('Username or password can\'t be blank', 'error');
      } else if (_.isObject(response)) {
        _.each(response, value => window.messages.add(value, 'error'));
      } else {
        window.messages.add(response, 'error');
      }
    } else {
      window.messages.add('Authorization successful');
    }
    this.ui.progress.addClass('hide');
    this.ui.auth.removeClass('disable');
  },

  /**
   * Send the authorisation data up to ParentPay to log the user in.
   * @returns {undefined}
   */
  auth() {
    const username = this.ui.username.val();
    const password = this.ui.password.val();
    const import_after = this.ui.import_after.val();
    const upload_after = this.ui.upload_after.val();
    const transaction_url = this.ui.last_url.val();

    // show spinner and disable button
    this.ui.progress.removeClass('hide');
    this.ui.auth.addClass('disable');

    this.model.save({
      username,
      password,
      import_after,
      upload_after,
      transaction_url
    });
  }
});

module.exports = AuthView;



// WEBPACK FOOTER //
// ./parentpay/views/auth/index.js